
import React from 'react';
import PropTypes from 'prop-types';

import { MediaAgeVerificationFrame, MediaPreviewVideo, MediaLockedCard } from 'common/designer-modules/modules/media/modules';
import Image from 'common/designer-modules/modules/media/story/image';

const StoryCard = ({
   story,
   isAgeVerificationRequired,
   onClickJoin = () => {},
   primaryColor,
}) => {
   const getStoryCover = () => {
      if('video' === story.type){
         return story?.full_thumbnail;
      }
      return story?.full_src?.[0];
   }
   const poster = getStoryCover();


   if(!story.has_access){
      return (
         <MediaLockedCard
            blurhash={ story.blurhash }
            onClick={ onClickJoin }
         />
      )
   }
   if('video' === story.type){
      return (
         <MediaPreviewVideo
            poster={ poster }
            src={ story.full_src }
            previewIsSFW={ !story.is_sfw && isAgeVerificationRequired }
            posterIsSfw={ !story.custom_thumbnail_is_sfw && isAgeVerificationRequired }
            primaryColor={ primaryColor }
         />
      );

   }
   if(!story.custom_thumbnail_is_sfw && isAgeVerificationRequired){
      return (
         <MediaAgeVerificationFrame
            src={ poster }
         />
      )
   }
   return (
      <Image
         story={ story }
         isAgeVerificationRequired={ isAgeVerificationRequired }
      />
   )

}
StoryCard.propTypes = {
   story: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
   onClickJoin: PropTypes.func,
   primaryColor: PropTypes.string,
};

export default StoryCard;


